import { t } from "i18next";
import { ServiceValidationWithId } from "./typings/ServiceValidationWithId.type";
import { SetStateAction } from "react";

function validateTime(value: number | null): boolean {
  return typeof value === "number" && value >= 0; // dont allow value === null
}

export function validateServiceTimeSet(
  rows: {
    bookingLeadTime: number | null;
    setUpTime: number | null;
  }[]
) {
  return {
    bookingLeadTime: rows.some(row => !validateTime(row.bookingLeadTime))
      ? t("_serviceTimeSetError", { item: t("Booking Lead Time") })
      : "",
    setUpTime: rows.some(row => !validateTime(row.setUpTime))
      ? t("_serviceTimeSetError", { item: t("Setup Time") })
      : ""
  };
}

// Helper function to check if the value is valid (either null or >= 0)
export const isValidValue = (value: number | null) => {
  return typeof value === "number" && value >= 0;
};

// Function to create error message for invalid fields
export const returnErrorMessage = (item: string) => t("_ServiceTimeSetError", { item: item });

export const validateAndSetErrors = (
  arr: Array<{ id: number; bookingLeadTime: number | null; setUpTime: number | null }>,
  setValidationErrors: (value: SetStateAction<ServiceValidationWithId>) => void,
  finishAssign: () => void
) => {
  let hasErrors = false;
  const newValidationErrors: ServiceValidationWithId = {};

  arr.forEach(item => {
    const errors: { setUpTime?: string; bookingLeadTime?: string } = {};

    // Validate setUpTime
    if (item.setUpTime === null || !isValidValue(item.setUpTime)) {
      errors.setUpTime = returnErrorMessage(t("Setup Time"));
      hasErrors = true;
    }

    // Validate bookingLeadTime
    if (item.bookingLeadTime === null || !isValidValue(item.bookingLeadTime)) {
      errors.bookingLeadTime = returnErrorMessage(t("Booking Lead Time"));
      hasErrors = true;
    }

    // Only add to newValidationErrors if there are errors for this item
    if (Object.keys(errors).length > 0) {
      newValidationErrors[item.id] = errors;
    }
  });

  if (hasErrors) {
    return setValidationErrors(newValidationErrors);
  } else {
    setValidationErrors({});

    // finalize assign service item and time
    finishAssign();
  }
};
